export const NOTIFICATIONS_SETTINGS = "NOTIFICATIONS_SETTINGS";
